export const DESKTOP_BREAKPOINT = 1280;
export const TABLET_BREAKPOINT = 960;
export const TABLET_PORTRAIT_BREAKPOINT = 670;
export const DEFAULT_MAP_KEY = 'd3c864b6-01f3-4748-b63c-688875219392\n';
